class PauseAd {

    /** PauseAd.js
     * Displays a banner ad when the video is paused.
     *
     * Based on the sample code provided by Tal from Google:
     * https://jsbin.com/yidulaleja/edit?html,js,output 
     * 
     * Virgin Code:
     * https://www.virginmediatelevision.ie/player/assets/video_js/videojs-pauseads-vodlimitedads.js?v=05100607
     */
    constructor(options) {

        console.log('Simplestream::PauseAd::Constructor()');

        // Validate options
        if(!options.container) {
            console.error('Simplestream::PauseAd: Missing container');
            return;
        } else if(!options.videoElement) {
            console.error('Simplestream::PauseAd: Missing videoElement');
            return;
        }

        // Set options
        this.container = options.container;
        this.videoElement = options.videoElement;
        this.vastTag = options.vastTag;
        this.nonce = options.nonce;
        this.init();

    }

    /**
     * Initialise the pause ad container and events.
     */
    init() {

        const htmlContent = `
        <div id="pauseAd" class="pausead-container">
            <div class="pausead-safearea">
                <div id="pauseAdSlot" class="pausead-slot"></div>
            </div>
            <div class="pausead-controls">
                <div id="pauseAdPlayButton" class="pausead-button">
                    Play
                </div>
            </div>
        </div>`;
        this.container.insertAdjacentHTML('beforeend', htmlContent);

        this.pauseAdContainer = document.getElementById('pauseAd');
        this.pauseAdPlayButton = document.getElementById('pauseAdPlayButton');
        this.pauseAdSlotContainer = document.getElementById('pauseAdSlotContainer');
        this.pauseAdSlot = document.getElementById('pauseAdSlot');

        this.pauseAdPlayButton.addEventListener('click', function() {
            this.pauseAdContainerDisplay('hide');
            this.videoElement.play();
        }.bind(this));

        let isSeeking = false;
        let pauseTimeout;
    
        // Listen for the 'pause' event
        this.videoElement.addEventListener('pause', () => {
            this.isPlayerPaused();
        });

        this.videoElement.addEventListener('play', () => {
            console.log('Simplestream::PauseAd::Event Play');
            this.pauseAdSlot.innerHTML = '';
            this.pauseAdContainerDisplay('hide');
        });

    }

    /**
     * Determine if the player is paused.
     */
    isPlayerPaused() {
        console.log('Simplestream::PauseAd::isPlayerPaused()');
        let currentTime = this.videoElement.currentTime;
        setTimeout(() => {
            let seekTime = this.videoElement.currentTime;
            if(seekTime != currentTime) {
                console.log('Simplestream::PauseAd::isPlayerPaused() - Not a pause event, currentTime has changed.');
            } else {
                console.log('Simplestream::PauseAd::isPlayerPaused() - Pause event confirmed.');
                this.checkPauseAdsAreAllowed();
            }
        }, 1500);
    }

    /**
     * Determine if the player is in a state ready for pause ads.
     */
    checkPauseAdsAreAllowed() {

        if(this.videoElement.seeking) {
            console.log('Video is seeking. Pause ad not allowed.');
            return
        }

        if(this.videoElement.dataset.stream != 'playing') {
            //console.log('Preolls have not finished. Pause ad not allowed.');
            //return;
        }

        if(this.videoElement.currentTime <= 10) {
            console.log('currentTime is less than 10 seconds. Pause ad not allowed.');
            return;
        }

        this.checkDimensions();

    }

    /**
     * Check player is large enough to show the pause ad.
     */
    checkDimensions() {

        console.log('Simplestream::PauseAd::checkDimensions()');

        // Get the dimensions of the pause ad slot
        this.pauseAdSlotDimensions = this.pauseAdSlot.offsetWidth + 'x' + this.pauseAdSlot.offsetHeight;
        console.log('Pause Ad Slot: ' + this.pauseAdSlotDimensions);

        if(this.pauseAdSlotDimensions == '0x0') {
            console.log('Pause Ad Slot is too small. Pause ad not allowed.');
            return false;
        }

        this.loadAdsManager();

    }

    /**
     * Load the Google IMA SDK and request the pause ad.
     */
    loadAdsManager() {

        console.log('Simplestream::PauseAd::loadAdsManager()');

        // Modify the VAST tag
        const urlObj = new URL(this.vastTag);
        urlObj.searchParams.delete('sz');
        urlObj.searchParams.delete('correlator');
        const vastTag = urlObj.toString() + '&sz=' + this.pauseAdSlotDimensions + '&correlator=' + Math.floor(Math.random() * 10000000000);

        console.log('VAST Tag: ' + vastTag);

        // Get the dimensions of the pause ad slot
        let [width, height] = this.pauseAdSlotDimensions.split('x');

        google.ima.settings.setPlayerType('shaka');
        google.ima.settings.setPlayerVersion('4.10.9');
        google.ima.settings.setLocale('en');
      
        // Create the ad display container.
        let adDisplayContainer = new google.ima.AdDisplayContainer(this.pauseAdSlot, this.videoElement);

        // Initialize the container. Must be done via a user action on mobile devices.
        adDisplayContainer.initialize();

        // Create ads loader.
        let adsLoader = new google.ima.AdsLoader(adDisplayContainer);

        // Listen and respond to ads loaded and error events.
        adsLoader.addEventListener(google.ima.AdsManagerLoadedEvent.Type.ADS_MANAGER_LOADED, this.onAdsManagerLoaded.bind(this), false);
        adsLoader.addEventListener(google.ima.AdErrorEvent.Type.AD_ERROR, this.onAdError.bind(this), false);

        // Request video ads.
        let adsRequest = new google.ima.AdsRequest();
        adsRequest.adTagUrl = vastTag;
        adsRequest.nonLinearAdSlotWidth = parseInt(width);
        adsRequest.nonLinearAdSlotHeight = parseInt(height);
        adsLoader.requestAds(adsRequest);

    }

    /**
     * After Google IMA SDK has loaded, show pause ad.
     */
    onAdsManagerLoaded(adsManagerLoadedEvent) {

        console.log('Simplestream::PauseAd::onAdsManagerLoaded()');

        let adsRenderingSettings = new google.ima.AdsRenderingSettings();
        adsRenderingSettings.autoAlign = false; // Aligns ad bottom center of pauseAdSlot
        adsRenderingSettings.restoreCustomPlaybackStateOnAdBreakComplete = true;
        
        this.adsManager = adsManagerLoadedEvent.getAdsManager(this.videoContent, adsRenderingSettings);
        this.adsManager.addEventListener(google.ima.AdErrorEvent.Type.AD_ERROR, this.onAdError.bind(this));
        this.adsManager.addEventListener(google.ima.AdEvent.Type.CONTENT_PAUSE_REQUESTED, this.onContentPauseRequested.bind(this));
        this.adsManager.addEventListener(google.ima.AdEvent.Type.CONTENT_RESUME_REQUESTED, this.onContentResumeRequested.bind(this));
        this.adsManager.addEventListener(google.ima.AdEvent.Type.ALL_ADS_COMPLETED, this.onAdEvent.bind(this));
        this.adsManager.addEventListener(google.ima.AdEvent.Type.LOADED, this.onAdEvent.bind(this));
        this.adsManager.addEventListener(google.ima.AdEvent.Type.STARTED, this.onAdEvent.bind(this));
        this.adsManager.addEventListener(google.ima.AdEvent.Type.COMPLETE, this.onAdEvent.bind(this));

        // Add window resize listener
        window.addEventListener('resize', () => {

            // Get the dimensions of the pause ad slot
            this.pauseAdSlotDimensions = this.pauseAdSlot.offsetWidth + 'x' + this.pauseAdSlot.offsetHeight;
            console.log('Resized Pause Ad Slot: ' + this.pauseAdSlotDimensions);

            if(this.pauseAdSlotDimensions == '0x0') {
                console.log('Resized Pause Ad Slot is too small. Hide Pause Ad.');
                return false;
            }

            // Get the dimensions of the pause ad slot
            let [width, height] = this.pauseAdSlotDimensions.split('x');
            width = (parseInt(width) + 20);
            height = (parseInt(height) + 20);

            this.adsManager.resize(width, height, google.ima.ViewMode.NORMAL);

        });
        
        // Get the dimensions of the pause ad slot
        let [width, height] = this.pauseAdSlotDimensions.split('x');
        width = (parseInt(width) + 20);
        height = (parseInt(height) + 20);

        try {
            this.pauseAdContainerDisplay('show');
            this.adsManager.init(width, height, google.ima.ViewMode.NORMAL);
            this.adsManager.start();
        } catch (adError) {
            alert('error');
        }

        this.adsManager.resize(width, height, google.ima.ViewMode.NORMAL);

    }

    /**
     * Hide/Show the pause ad container by adjusting the z-index.
     */
    pauseAdContainerDisplay(state) {
        console.log('Simplestream::PauseAd::pauseAdContainerDisplay(\'' + state + '\')');
        if(state == 'show') {
            this.pauseAdContainer.style.zIndex = 10000;
        } else {
            this.pauseAdContainer.style.zIndex = -1;
        }
    }
    
    /**
     * Handle ad events.
     */
    onAdEvent(adEvent) {

        console.log('Simplestream::PauseAd::onAdEvent() - ' + adEvent.type);

        switch (adEvent.type) {
            case google.ima.AdEvent.Type.LOADED:
                break;
            case google.ima.AdEvent.Type.STARTED:
                this.pauseAdContainerDisplay('show');
                console.log('Pause Ad', adEvent.getAd());
                break;
            case google.ima.AdEvent.Type.COMPLETE:
                break;
        }

    }
    
    /**
     * Handle ad error.
     */
    onAdError(adErrorEvent) {
        console.log('Simplestream::PauseAd::onAdError()');
        let error = adErrorEvent.getError();
        console.error('Code: ' + error.data.errorCode + ' / Message: ' + error.data.errorMessage);
        //this.adsManager.destroy();
        //this.pauseAdContainerDisplay('hide');
    }
    
    /**
     * Is this needed?
     */
    onContentPauseRequested() {
        console.log('Simplestream::PauseAd::onContentPauseRequested()');
        this.videoContent.pause();
    }
    
    /**
     * Is this needed?
     */
    onContentResumeRequested() {
        console.log('Simplestream::PauseAd::onContentResumeRequested()');
        this.videoContent.play();
    }

}

export default PauseAd;